import {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {Button, Tooltip, withStyles} from "@material-ui/core";
import clsx from 'clsx';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import DeleteExperiencesModal from "../../../atoms/modals/deleteExperiencesModal";
import MergeExperiencesModal from "../../../atoms/modals/mergeExperiencesModal";
import AddNewReelModel from "../../../atoms/modals/addNewReelModel";
import AddToProjectModal from "../../../atoms/modals/addToProjectModal";
import {SESSION_SMALL_THUMBNAIL} from '../../../../config/mock';
import ImmersionModal from "../../../atoms/modals/commonModal";
import apiConfigs from "../../../../config/config";
import {Feature, useFeature} from 'flagged';
import lockIcon from '@material-ui/icons/Lock';
import Icon from '@material-ui/core/Icon';
import {
  getCreatorList,
  onSetChecked,
  onSetSearchText,
  onSetSelected,
  onSetUserDropdown,
  updatesearchfilters,
  updateSearchKey,
  updateSearchText,
  updateSearchUsers
} from "../../../../store/actions/experience/experience";
import CustomSnackBar from "../experienceManager/participantsDashboard/component/CustomSnackBar";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#ff0000',
    maxWidth: 260,
    marginLeft: 75,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    }
  }))(Tooltip);

const useStyles = makeStyles(() => ({
  container: {
    width: '100%'
  },
  content: {
    position: 'fixed',
    bottom: 0,
    zIndex: 1000,
    borderRadius: 6,
    transition: 'bottom 0.5s ease-out',
    width: 'calc(100% - 65px)',
    '@media (max-width: 960px)': {
        width: '100%'
    }
  },
  hidden: {
    bottom: -225
  },
  shown: {
    bottom: 0
  },
  full: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  note: {
    background: '#fff',
    height: 23,
    width: 122,
    boxShadow: '0 1px 15px rgba(0, 0, 0, 0.24), 0 1px 6px rgba(0, 0, 0, 0.24)',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    '&:hover': {
        cursor: 'pointer'
    }
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    padding: 15,
    width: '100%',
    boxShadow: '0 1px 15px rgba(0, 0, 0, 0.14), 0 1px 6px rgba(0, 0, 0, 0.14)'
  },
  bar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'roboto-black',
    fontSize: 14,
    color: '#017AEF',
    background: '#fff',
    height: 23,
    width: 120,
    marginTop: -36,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    '&:hover': {
        cursor: 'pointer'
    }
  },
  hlpCenter: {
    fontFamily: 'roboto-black',
    fontSize: 14,
    color: '#017AEF',  
    cursor:"pointer"
  },
  item: {
    marginLeft: 11,
    marginRight: 11,
    position: 'relative',
  },
  img: {
    width: 210,
    height: 135,
    borderRadius: 20,
    marginTop: 30,
    objectFit: 'cover'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 100,
    alignItems: 'center',
  },
  itemText: {
    fontFamily: 'roboto-regular',
    margin: 0,
    fontSize: 14,
    color: '#000',
    textAlign: 'center',
    maxHeight: 35
  },
  itemTextClip: {
    fontFamily: 'roboto-bold',
    margin: 0,
    fontSize: 14,
    color: '#000',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    maxHeight: 35,
    marginLeft: 4,
    overflow: 'hidden',
  },
  btnGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: 100,
    marginTop: '5px',
  },
  btn: {
    width: 87,
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
        background: '#0f9fef',
        color: '#fff',
    },
    margin: '0 15px',
  },
  defaultBtn: {
    margin: '0 15px',
    padding: '0 14px',
    height: 37,
    borderRadius: 6,
    background: '#f2f2f2',
    textTransform: 'none',
    fontSize: 14,
    color: '#9ea6ae',
    '&:hover': {
        background: '#c8c8c8',
    }
  },
  defaultReelBtn: {
    padding: '0 14px',
    height: 37,
    borderRadius: 6,
    background: '#f2f2f2',
    textTransform: 'none',
    fontSize: 14,
    color: '#9ea6ae',
    '&:hover': {
      background: '#c8c8c8'
    },
  },
  removeProjectBtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
  },
  remove: {
    position: 'absolute',
    right: -17,
    top: 21,
    '&:hover': {
        cursor: 'pointer'
    }
  },
  carousel: {
    display: 'flex',
    flexDirection: 'row',
    height: 311,
    width: '100%',
    overflowX: 'auto',
    justifyContent: 'center'
  },
  carouselContainer: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '100%',
    alignItems: 'flex-start',
    marginTop: '-5px'
  },
  btnClear: {
    margin: '0 15px',
    color: '#9ea6ae',
    textTransform: 'none'
  },
  bodyHeightHidden: {
    height:225
  },
  bodyHeightOpen: {
    height:278
  },
  description: {
    color: '#697683',
    fontSize: 14,
    lineHeight: 1.5,
    fontFamily: 'roboto-regular'
  }
}));

interface IProps {
  sessions: any,
  hideAddToProject: boolean,
  selected: any[];
  clearAll: () => void,
  onRemove: (item: any) => void,
  onCompare: () => void,
  RemoveReelSession?: () => void,
  onExport?: () => void
}

const CreatorTray = (props: IProps) => {
  const [hidden, setHidden] = useState(true);
  const classes = useStyles();
  const { selected, clearAll, onRemove, onCompare, sessions, hideAddToProject, RemoveReelSession, onExport } = props;
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [type, setType] = useState(""); //type is adding experience to project or removing
  const [showAddToProjectModal, setShowAddToProjectModal] = useState(false);
  const [openCreateReel, setOpenCreateReel] = useState(false);
  const [batchAsyncRole, setBatchAsyncRole] = useState(false);
  const [asyncLiveRole, setasyncLiveRole] = useState(false);
  const [reelsButtonStatus, setReelsButtonStatus] = useState(true);
  const [reelsMessage, setReelsSessionType] = useState("");
  const [addReelModel, setAddReelModel] = useState(false);
  const [stepname, setStepName] = useState("");
  const { showMergeButton } = useSelector((state: any) => state.experience);
  const [openMergeClips, setopenMergeClips] = useState(false);
  const [mergeButtonStatus, setMergeButtonStatus] = useState(true);
  const [snackAlertType, setSnackAlertType] = useState('');
  const [snackAlertMsg, setSnackMsg] = useState('');
  const [showSnackAlert, setShowSnackAlert] = useState(false);

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  const hasFeatureReels = useFeature('feature_reels');


  useEffect(() => {
    if (loginUserData && loginUserData.role_access) {
      if (loginUserData.role_access.length) {
        const batch_async = loginUserData.role_access.filter((val:any) => val.access_name === "batch_async");
        if (batch_async.length > 0 && batch_async[0].access_value) {
          setBatchAsyncRole(true)
        }
      }
      if (loginUserData.role_access.length) {
        const async_live = loginUserData.role_access.filter((val:any) => val.access_name === "async_live");
        if (async_live.length > 0 && async_live[0].access_value) {
          setasyncLiveRole(true)
        }
      }
    }
  }, []);

  useEffect(() => {
    setReelsSessionType("");
    setReelsButtonStatus(true);
    setMergeButtonStatus(true);
    
    if (selected && selected.length < 2) {
      setReelsButtonStatus(false);
      setMergeButtonStatus(false);
    } else if (selected && selected.length >= 2) {
      selected.map((session:any) => {
        if (session.stimulus_status !== "READY") {
          setReelsSessionType("We`re sorry, but you can`t add an experience to a reel while we`re still processing the video. Not to worry: we`ll email you when each video is finished processing. so you know when to come back and finish.");
        }
        if (session.session_type !== "ASYNC") {
          setReelsButtonStatus(false);
        }
        if (isClipped(session)) {
          setReelsButtonStatus(false);
        }
        if (session.session_type !== "MODERATED") {
          setMergeButtonStatus(false);
        }
        if ((session.session_status ? session.session_status : session.status) !== "COMPLETED") {
          setMergeButtonStatus(false);
        }
      });
    } else {
      setReelsSessionType("");
    }
  }, [selected]);

  const onCheckSameExperienceClips = (selectedList: any[]) => {
    const sessionCodes = selectedList.map((item: any) => item.session_code);
    const isDuplicated = sessionCodes.some((session_code: string, idx: number) => {
      return sessionCodes.indexOf(session_code) != idx;
    });

    return isDuplicated
  };

  const goToDashboard = () => {
    dispatch(onSetSearchText(""));
    dispatch(onSetChecked([]));
    dispatch(onSetSelected([]));
    dispatch(onSetUserDropdown(false));
    dispatch(updateSearchKey(''));
    dispatch(updateSearchText(''));
    dispatch(updateSearchUsers([]));
    dispatch(updatesearchfilters('clear'));
    dispatch(getCreatorList(null));
    localStorage.removeItem('search_sort_request');
  };

  const handleMergeClose = () => {
    setopenMergeClips(!openMergeClips);
    goToDashboard();
  };
  
  const handleClose = () => {
    setModal(!modal);
  };

  const handleAddToProjectModal = (type: any) => {
    setType(type);
    setShowAddToProjectModal(!showAddToProjectModal);
  };

  const onAddedToProject = () => {
    setShowAddToProjectModal(!showAddToProjectModal);
    goToDashboard();
  };

  const onClickExport = () => {
    onExport && onExport();
    checkRedirectToDashboard();
  };

  const checkRedirectToDashboard = () => {
    const selectedSessions = selected.filter((s: any) => {
      if (s && !s.hasOwnProperty('clip_id')) {
        return s
      }
    });
    const selectedClips = selected.filter((s: any) => {
      if (s && s.hasOwnProperty('clip_id')) {
        return s
      }
    });

    const nonCompletedSessions = selectedSessions.filter((session: any) => session.status !== 'COMPLETED');
    const nonCompletedClips = selectedClips.filter((clip: any) => clip.session_status !== 'COMPLETED');

    if (nonCompletedSessions.length === 0 && nonCompletedClips.length === 0) {
      goToDashboard();
    }
  };

  const isClipped = (session: any) => {
    if (!session) return;

    return (String(session.session_id).includes('clip-'));
  };

  const truncateName = (string: any) => {
    if (string && string.length > 25) {
      return string.substring(0, 24) + "...";
    } else {
      return string;
    }
  };

  const getItemName = (session: any) => {
    if (!session) return;

    if (isClipped(session)) {
      const parentSession = sessions.find((item: any) => ((item.session_code === session.session_code)));
        
      if (parentSession) {
        return truncateName(parentSession.name);
      } else if (session.clipList) {
        return truncateName(session.session_title);
      }
    } else {
      return truncateName(session.name);
    }
  };

  const goToKnowledge = () => {
    const url = `${apiConfigs.COMPANY_URL}/creating-a-reel`;
    window.open(url, "__blank");
  };

  const MergeClips = () => {
    // don't show "Merge" button if puts two clips from the same experience
    const is_same_experience = onCheckSameExperienceClips(selected);
    if (is_same_experience) {
      setSnackAlertType('warning');
      setShowSnackAlert(true);
      setSnackMsg('You cannot merge two clips from the same experience.');
      return;
    } else {
      setopenMergeClips(true);
    }
  };

  const createReel = () => {
    setOpenCreateReel(true)
  };

  const handleCloseCreateModal = () => {
    setOpenCreateReel(false)
  };

  const onAddReel = () => {
    setOpenCreateReel(false);
    setAddReelModel(true);
    setStepName('Schedule');
  };

  const handleAddReelClose = () => {
    setAddReelModel(false);
  };

  const hideSnackAlert = () => {
    setShowSnackAlert(false);
  };
  
  return (
    <div className={classes.container}>
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={showSnackAlert} onClose={hideSnackAlert} />
      <div className={clsx(classes.content, !hidden ? classes.hidden : classes.shown)} style={hideAddToProject ? { width: '100%'} : {}}>
        <div className={classes.full}>
          <div className={classes.note} onClick={() => setHidden(!hidden)} />
          <div className={clsx(classes.body, hidden ? classes.bodyHeightOpen : classes.bodyHeightHidden)}>
            <div className={classes.bar} onClick={() => setHidden(!hidden)}>
              <span>{selected.length} Selected</span>
              {hidden ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </div>
            <div className={classes.carousel}>
              <div className={classes.carouselContainer}>
                {selected.map((item: any, index: number) =>
                  <div key={index} className={classes.item}>
                    <img
                        src={isClipped(item) ? (`${apiConfigs.S3_IMG_URL}/large-${typeof item.immersion === 'number' ? (item.immersion % 70 + 1) : 64}.svg`) : (item.img_large ? item.img_large : SESSION_SMALL_THUMBNAIL)}
                        alt='{img}'
                        className={classes.img}
                        onError={e => e.currentTarget.src = SESSION_SMALL_THUMBNAIL}
                    />
                    <img onClick={() => onRemove(item)} src={'/assets/icons/dashboard/remove.svg'} className={classes.remove} alt="{close}" />
                      <div>
                        <div>
                          <p className={clsx(classes.itemText, 'line-clamp-1')}>
                              {getItemName(item)}
                          </p>
                        </div>

                        {isClipped(item) &&
                          <div className={classes.row}>
                            <img src={'/assets/icons/dashboard/scissors.svg'} alt='{img}' />
                            <p className={clsx(classes.itemTextClip, 'line-clamp-1')}>
                            {truncateName(item.name)}
                            </p>
                          </div>
                        }
                      </div>
                  </div>)
                }
              </div>
            </div>
            <div className={classes.btnGroup}>
              <div>
                {batchAsyncRole && reelsButtonStatus && 
                  <HtmlTooltip disableFocusListener
                    title={reelsMessage ? <div>{reelsMessage}</div> : ""}
                  >
                    {reelsMessage ? 
                      <Button color='primary' className={classes.defaultReelBtn}>
                        Create Reel
                      </Button> 
                      :
                      ( hasFeatureReels ? 
                      <Button color='primary' className={classes.defaultReelBtn} onClick={createReel}>
                        Create Reel
                      </Button>
                      :
                      <Button color='primary' className={classes.defaultReelBtn}>
                        <Icon component={lockIcon} color="primary"/>
                        Create Reel
                      </Button> 
                      )
                    } 
                  </HtmlTooltip>
                }
              </div>
              <div style={{ marginRight: -30 }}>
                <Button color='primary' className={classes.btnClear} onClick={clearAll}>Clear All</Button>
                {asyncLiveRole && mergeButtonStatus && showMergeButton &&
                  <Button className={classes.defaultBtn} onClick={MergeClips}>
                    Merge
                  </Button>
                }
                {hideAddToProject === false &&
                  <Button className={classes.defaultBtn} onClick={() =>handleAddToProjectModal("isAdd")}>Add to
                    Project
                  </Button>
                }
                <Button
                  color='primary'
                  className={classes.btn}
                  onClick={() => {
                    if (onCompare) onCompare();
                  }}
                >
                  Compare
                </Button>
                {selected.length > 0 && (
                  <Feature name="feature_export_data">
                  <Button
                    color='primary'
                    className={classes.btn}
                    onClick={() => {
                      if (onExport) onClickExport();
                    }}
                  >
                    Export
                  </Button>
                  </Feature>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <MergeExperiencesModal
        open={openMergeClips}
        onClose={handleMergeClose}
        selected={selected}
        clearAll={clearAll}
      />
      <DeleteExperiencesModal
        open={modal}
        onClose={handleClose}
        selected={selected}
        clearAll={clearAll}
      />
      <AddNewReelModel
        open={addReelModel}
        onClose={handleAddReelClose}
        selected={selected}
        onRemove = {(item: any)=> onRemove(item)}
        clearAll={clearAll}
        step={stepname}
        RemoveReelSession={RemoveReelSession}
      />
      {showAddToProjectModal && 
        <AddToProjectModal
          open={showAddToProjectModal}
          onClose={handleAddToProjectModal}
          onAdded={onAddedToProject}
          selected={selected}
          type={type}
        />
      }
      <ImmersionModal
        open={openCreateReel}
        title={'Create Reel'}
        parent={'createReel'}
        size={'sm'}
        description={` `}
        titleOK={'Create'}
        titleCancel={'Cancel'}
        onClose={handleCloseCreateModal}
        additional={ 
          <>
            <p className={classes.description}>
                Creating a reel allows you to send a batch of the experiences to a single set of participants to be measured.
            </p>
            <p className={classes.description}>
            Once measured, you will see the results at the experience level as you do for any other experience measured on its own.
            </p>
            <p className={classes.description} onClick={() => goToKnowledge()}>
                For more information about Reels,<span className={classes.hlpCenter}> visit our Knowledge Center.</span>
            </p>
          </>
        }
        onApply={onAddReel}
      />
    </div>
  )
}

export default CreatorTray;
